<template>
  <div v-if="NOTARIA">

    <!-- Start Breadcrump Area  -->
    <SliderBannerNotinTwo :obj="NOTARIA.Theme.Contacto" type="contacto"/>
    <!-- End Breadcrump Area  -->

    <!-- Start Contact Address Area  -->
    <ContactAddressNotinOne/>
      
    <!-- End Contact Address Area  -->

    <!-- Start Contact Area  -->
    <ContactFormNotinOne v-if="NOTARIA && NOTARIA.Theme && NOTARIA.Theme.Contacto.Form.Mostrar" :contactForm="NOTARIA.Theme.Contacto.Form"/>
    <!-- End Contact Area  -->

    <!-- Start Brand Area -->
    <!-- <div class="rn-brand-area brand-separation rn-section-gap bg_color--5">
      <v-container>
        <Brand />
      </v-container>
    </div> -->
    <!-- End Brand Area -->
  </div>
</template>

<script setup lang="ts">
import { useStore } from '../store/index'
const store = useStore()
const {NOTARIA} = storeToRefs(store)
const PageName = "Contacto"
if(store.NOTARIA) useMetaTags(toRaw(store.NOTARIA),PageName)
</script>
